import isMatch from 'lodash/isMatch';

import { type AnalyticsEventPayload, type UIAnalyticsEvent } from '@atlaskit/analytics-next';

import type { Callback, Matcher, PostOfficeGasv3ListenerStore } from './types';

function getSubscribers(): Map<Matcher, Callback> {
	if (typeof window !== 'undefined' && window.postOffice?.gasv3Listener?.subscribers) {
		return window.postOffice!.gasv3Listener!.subscribers!;
	}

	if (typeof window !== 'undefined') {
		window.postOffice = {
			...window.postOffice,
			gasv3Listener: {
				...window.postOffice?.gasv3Listener,
				subscribers: new Map<Matcher, Callback>(),
			},
		};

		return window.postOffice!.gasv3Listener!.subscribers!;
	}

	return new Map<Matcher, Callback>();
}

const createPostOfficeGasv3ListenerStore = (): PostOfficeGasv3ListenerStore => {
	const subscribers = getSubscribers();

	const handleEvent = (event: UIAnalyticsEvent) => {
		subscribers.forEach((callback, matcher) => {
			if (isMatch(event.payload, matcher)) {
				callback();
			}
		});
	};

	const subscribe = (matcher: AnalyticsEventPayload, callback: Callback) => {
		subscribers.set(matcher, callback);

		return () => {
			subscribers.delete(matcher);
		};
	};

	return {
		subscribe,
		handleEvent,
	};
};
const postOfficeGasv3ListenerStore: PostOfficeGasv3ListenerStore = createPostOfficeGasv3ListenerStore();

export { postOfficeGasv3ListenerStore };
